import { render } from "./AddElementModal.vue?vue&type=template&id=a7bd6968&ts=true"
import script from "./AddElementModal.vue?vue&type=script&lang=ts"
export * from "./AddElementModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__